import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { projectsApi, type OnchainEvent, ApiError } from "@/api/client";
import { AppShell } from "@/components/AppShell";
import { OnchainActivity } from "@/components/OnchainActivity";

/** Histórico on-chain de tudo (admin), com filtro opcional por projeto. */
export default function AdminActivity() {
  const [events, setEvents] = useState<OnchainEvent[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [slug, setSlug] = useState("");

  function load(filterSlug?: string) {
    setLoading(true);
    projectsApi.activity(filterSlug || undefined)
      .then((r) => setEvents(r.events))
      .catch((err) => setError(err instanceof ApiError ? err.message : err.message))
      .finally(() => setLoading(false));
  }

  useEffect(() => { load(); }, []);

  return (
    <AppShell>
      <div className="max-w-5xl mx-auto p-6">
        <Link to="/admin/projects" className="text-sm underline text-app-muted hover:text-app-accent">
          ← projetos
        </Link>
        <h1 className="text-2xl font-bold my-4">Atividade on-chain</h1>
        <p className="text-sm text-app-muted mb-4">
          Todas as transações disparadas pelo sistema — deploys, distribuições, vestings e saques —
          com link pro Basescan.
        </p>

        <div className="flex gap-2 mb-4">
          <input value={slug} onChange={(e) => setSlug(e.target.value)}
                 placeholder="filtrar por slug do projeto (opcional)"
                 className="flex-1 px-3 py-2 text-sm" />
          <button onClick={() => load(slug)}
                  className="bg-app-accent text-app-accent-text rounded px-4 py-2 text-sm font-medium hover:opacity-90">
            Filtrar
          </button>
          {slug && (
            <button onClick={() => { setSlug(""); load(); }}
                    className="border border-app-border rounded px-3 py-2 text-sm hover:bg-app-surface-2">
              limpar
            </button>
          )}
        </div>

        {loading && <p className="text-sm text-app-muted">Carregando...</p>}
        {error && <div className="bg-red-500/10 border border-red-500/40 rounded p-3 text-sm text-red-500 mb-3">{error}</div>}
        {!loading && !error && <OnchainActivity events={events} />}
      </div>
    </AppShell>
  );
}
